<template>
    <v-container fluid>
      <v-overlay :value="uploading" opacity="0.7">
        <v-progress-circular  size="100" width="7" :rotate="-90" color="primary" :value="importProgress">{{importProgress}}%</v-progress-circular>      
      </v-overlay>
      <a-page-header title="Imports" icon="flaticon-cloud-computing"/>    

      <v-divider/>

      <v-row>
        <v-col sm="12">
          <v-tabs v-model="tab">
            <v-tab href="#tab-1">CARBURANT</v-tab>
            <v-tab href="#tab-2">ENTRETIENS</v-tab>
            <v-tab href="#tab-3">PARC VEHICULES</v-tab>            
            <v-tab href="#tab-4">SITES FOURNISSEURS</v-tab>          
          </v-tabs> 

          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">   
              <!--- IMPORT CARBURANT 
              --------------------->              
              <v-row class="pa-5" justify="space-around">
                <v-col
                  v-for="fuelImport in fuelImportsSelection"
                  :key="fuelImport.id"
                  cols="12"
                  md="3"
                  class="mb-2"                  
                  @click="onClickBtnImport(1, fuelImport.id)"
                >
                  <v-card class="action-card" outlined hover v-ripple>
                    <div class="action-card__title subtitle-2 pa-3">IMPORT CARBURANT {{fuelImport.name}}</div>
                    <v-divider/>
                    <v-card-text class="d-flex align-center justify-center pa-10">
                      <v-img
                        class="action-card__media"
                        height="100"                        
                        contain
                        :src="`${$constants.application.resourcesURL}/images/${fuelImport.image}`"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>       
            </v-tab-item>

            <v-tab-item value="tab-2"> 
              <!--- IMPORT ENTRETIENS 
              ---------------------->
              <v-row class="pa-5" justify="space-around">
                <v-col
                  v-for="serviceImport in serviceImportsSelection"
                  :key="serviceImport.id"
                  cols="12"
                  md="3"
                  class="mb-2"
                  @click="onClickBtnImport(2, serviceImport.id)"
                >
                  <v-card class="action-card" outlined hover v-ripple>
                    <div class="action-card__title subtitle-2 pa-3">IMPORT {{serviceImport.name.replace('_', ' ')}}</div>
                    <v-divider/>
                    <v-card-text class="d-flex align-center justify-center pa-10">
                      <v-img
                        class="action-card__media"
                        height="100"                        
                        contain
                        :src="`${$constants.application.resourcesURL}/images/${serviceImport.image}`"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>                       
            </v-tab-item>

            <v-tab-item value="tab-3">          
              <!--- IMPORT FLOTTE 
              ------------------>
              <v-row class="pa-3" v-if="importType === 0 || (importType === 3 && importId !==0)">               
                <v-row class="pa-5" justify="space-around" v-if="customer !== undefined">
                  <v-col
                    cols="12"
                    md="3"
                    class="mb-2"
                  >
                    <div class="subtitle-2">Import parc automobile {{customer.name}}</div>
                    <v-btn height="100%" block class="pa-3">  
                        <v-img 
                          max-height="100"
                          max-width="100"
                          :src="customer.image" 
                        />                                         
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col sm="12" class="text-right">                    
                    <v-btn
                      color="primary"
                      text
                      x-small
                      tile
                      :href="$constants.application.defaultURL + '/download/template/fleet'"
                    >
                      Récuperer le fichier d'import                      
                      <v-icon
                        right
                        dark
                      >
                        mdi-cloud-download
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col sm="12">
                    <a-customer-list     
                      single-select             
                      @clickRow="onClickRow"          
                    />    
                  </v-col>    
                </v-row> 
              </v-row>            
            </v-tab-item>

            <v-tab-item value="tab-4">   
              <!--- IMPORT SITES 
              ------------------>
              <v-row class="pa-3" v-if="importType === 0 || (importType === 4 && importId !==0)">
                <v-row class="pa-5" justify="space-around" v-if="provider !== undefined">
                  <v-col
                    cols="12"
                    md="3"
                    class="mb-2"
                  >
                    <div class="subtitle-2">Import garage {{provider.name}}</div>
                    <v-btn height="100%" block class="pa-3">  
                        <v-img 
                          max-height="100"
                          max-width="100"
                          :src="provider.image" 
                        />                                         
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col sm="12">
                    <a-provider-list     
                      provider-type="2,4"
                      only-import
                      single-select             
                      @clickRow="onClickRowProvider"          
                    />    
                  </v-col>    
                </v-row> 
              </v-row>       
            </v-tab-item>

          </v-tabs-items>
        </v-col>
      </v-row>                                  

      <v-fade-transition >
        <v-row class="pa-3" v-if="importType !== 0 && importId !==0">
          <v-col md="12">
            <v-file-input
              label="Fichier à importer"
              filled
              show-size
              @change="onChangeFile"
            ></v-file-input>
          </v-col>

          <v-col md="12" class="text-right">
            <v-btn                  
                    color="error"
                    class="mr-4"
                    @click="onClickBtnCancel"
                  >
                    Annuler
                  </v-btn>  
            
            <v-btn                  
                    color="primary"
                    class="mr-4"
                    @click="onClickBtnImportFile"
                    :disabled="file === undefined"
                  >
                    Importer
                  </v-btn>  
          </v-col>
        </v-row>
      </v-fade-transition >

      <v-dialog
        v-model="fuelImportDialog"
        max-width="1100"
      >
        <v-card>
          <v-card-title>Récapitulatif import carburant</v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-left">Opération</th>
                  <th class="text-left">ID prise</th>
                  <th class="text-center">Immatriculation</th>
                  <th class="text-center">Date</th>
                  <th class="text-center">Heure</th>
                  <th class="text-right">Montant total</th>
                  <th class="text-right">Montant</th>
                  <th class="text-right">Km déclarés</th>
                  <th class="text-right">Km véhicule</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fuelImportDisplayRows" :key="index">
                  <td class="text-left">
                    <v-icon
                      v-if="row.operationIcon"
                      :color="row.operationColor"
                      small
                    >
                      {{ row.operationIcon }}
                    </v-icon>
                    <span v-else>{{ row.operation }}</span>
                  </td>
                  <td>{{ row.fuelIntakeId }}</td>                  
                  <td class="text-center">{{ row.registration }}</td>
                  <td class="text-center">{{ row.date }}</td>
                  <td class="text-center">{{ row.time }}</td>
                  <td class="text-right">{{ row.totalAmount }}</td>
                  <td class="text-right">{{ row.amount }}</td>
                  <td class="text-right">{{ row.declaredKm }}</td>
                  <td class="text-right">{{ row.storedKm }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="fuelImportDialog = false">FERMER</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  
</template>

<script>
import { mapGetters } from 'vuex'
import APageHeader from "@/components/APageHeader"

import ACustomerList from "@/components/ACustomerList"
import AProviderList from "@/components/AProviderList"


export default {
  name: 'Imports',
  components: { APageHeader, ACustomerList, AProviderList },
  data: () => ({   
    tab: 0, 
    fab: false,    
    fuelImports: [],
    serviceImports: [],    
    importType: 0,
    importId: 0,
    customer: undefined,
    provider: undefined,
    file: undefined,
    uploading: false,
    fuelImportDialog: false,
    fuelImportRows: [],
    importProgress: 0,
  }),
  methods: {
    // Méthodes évènements UI
    // ----------------------
    onClickBtnImportFile: function() {
      if (this.uploading) return
      this.uploading = true
      let url = `upload`
      const formData = new FormData()      
      formData.append('id', this.importId)
      formData.append('type', this.importType)
      formData.append('file', this.file, this.file.name)
      
      this.$http    
          .post(url, formData)           
          .then(response => {       
            if (response.status == 200) { 
              const taskId = response.data.task_id
              console.log('Upload successful, task id ', taskId)
              this.startWorker(taskId)
              this.getStatus(taskId)
            }                                 
          })
          .catch(error => {    
              console.log(error)                              
              if (error.response.status === 401) this.$root.$emit("logout"); 
              else this.$root.$emit("serverError", error);     
          })          
    },
    onClickBtnImport: function(type, id) {
      this.importType = type
      this.importId = id
    },
    onClickBtnCancel: function() {
      this.importType = 0
      this.importId = 0
      this.customer = undefined
      this.provider = undefined
    },
    onClickBtnDownloadTemplate: function(template) {
      if (template !== '') {
        let url = `download/template/${template}`
        window.open(url, '_blank')    
      }   
    },
    onChangeSelection: function(event) {
      this.selectedItems = event      
    },
    onClickRow: function(row) {
      this.customer = row
      this.onClickBtnImport(3, row.id)
    },
    onClickRowProvider: function(row) {
      this.provider = row
      this.onClickBtnImport(4, row.id)
    },
    onChangeFile: function(file) {
      this.file = file;      
    },
    getImports: function() {
      let url = `providers/types/0?import`
      this.$http
          .get(url)            
          .then(response => {                        
              if (response.status == 200) {             
                response.data.forEach(el => {
                  switch (el.type) {
                    case 1:
                      this.fuelImports.push(el)
                      break
                    
                    case 2:
                      this.serviceImports.push(el)
                      break

                    default:
                  }
                })
                
              }              
          })
          .catch(error => {                              
              if (error.response.status === 401) this.$root.$emit("logout")
              else this.$root.$emit("serverError", error)
          })
    },
    startWorker: function(task) {
      console.log('Starting worker for task ', task)
      let url = `worker/${task}`
      this.$http    
          .get(url)                    
          .then(response => {       
            if (response.status == 200) { 
              this.uploading = false
            }                                          
          })
          .catch(error => {    
              console.log(error)                              
              if (error.response.status === 401) this.$root.$emit("logout"); 
              else this.$root.$emit("serverError", error);     
          })
    },
    getStatus: function(taskId) {
      let url = `worker/status/${taskId}`
      console.log('Checking status for task ', url)
      this.$http    
        .get(url)                    
        .then(async response => {       
          if (response.status == 200) { 
            console.log('Status response ', response.data)
            if (response.data.status === 'completed') {
              const result = await this.getImportResults(response.data.result)
              this.uploading = false
              console.log('Import results ', result)
              const fuelImportRows = this.extractFuelImportRows(result)
              if (fuelImportRows.length > 0) {
                this.fuelImportRows = fuelImportRows
                this.fuelImportDialog = true
              }
              this.importType = 0
              this.importId = 0
              this.importProgress = 0
              this.customer = undefined     
              this.provider = undefined     
              this.file = undefined   
            }
            else {
              this.importProgress = response.data.progress
              this.uploading = true
              setTimeout(() => {
                this.getStatus(taskId)
              }, 1000)
            }   
          }                                                
        })
        .catch(error => {    
            console.log(error)                              
            if (error.response.status === 401) this.$root.$emit("logout"); 
            else this.$root.$emit("serverError", error);     
        })
    },
    getImportResults: async function(result) {
      try {
        // Journal servi par l'API (jeton obligatoire), plus directement par le domaine resources
        let url = `download/importlog/${encodeURIComponent(result)}`
        let response = await this.$http.get(url)    
        console.log('Import results response ', response)                 
        if (response.status == 200) { 
          return response.data
        } 
      } catch (error) {
        console.log('Error fetching import results ', error)
        return ''
      }                                        
    },
    extractFuelImportRows: function(data) {
      console.log('Extracting fuel import rows from data ', data)
      // Assuming data is in CSV format, we parse it
      const rows = []
      const lines = data.split('\n')
      for (let i = 0; i < lines.length; i++) { // Skip header
        const line = lines[i].trim()
        if (line) {
          const columns = line.split(',')
          rows.push(columns)
        }
      }
      return rows
    },
    formatAmount: function(value) {
      const number = parseFloat(value)
      return Number.isFinite(number) ? number.toFixed(2) : value
    },
    getOperationDisplay: function(operation) {
      console.log('Getting operation display for ', operation)
      switch (operation) {
        case 'U':
          return { icon: 'mdi-refresh-circle', color: 'green' }
        case 'C':
          return { icon: 'mdi-plus-circle', color: 'green' }
        case 'X':
          return { icon: 'mdi-close-circle', color: 'red' }
        default:
          return { icon: '', color: '' }
      }
    }
  },
  watch: {
    tab: function() {
      this.onClickBtnCancel()
    }
  },
  computed: {
    ...mapGetters([
      'userEnvironment'
    ]),
    fuelImportsSelection: function() {
      if (this.importType === 0) return this.fuelImports
      if (this.importType === 1) return this.fuelImports.filter(el => this.importId === 0 || el.id === this.importId)
      else return []
    },
    serviceImportsSelection: function() {
      if (this.importType === 0) return this.serviceImports
      if (this.importType === 2) return this.serviceImports.filter(el => this.importId === 0 || el.id === this.importId)
      else return []
    },
    fuelImportDisplayRows: function() {
      return this.fuelImportRows.map(row => {
        const [
          operation,
          fuelIntakeId,
          registration,
          date,
          time,
          totalAmount,
          amount,
          declaredKm,
          storedKm
        ] = row
        const normalizedOperation = String(operation || '').toUpperCase()
        const { icon, color } = this.getOperationDisplay(normalizedOperation)
        return {
          operation: normalizedOperation,
          operationIcon: icon,
          operationColor: color,
          fuelIntakeId,
          registration,
          date,
          time,
          totalAmount: this.formatAmount(totalAmount),
          amount: this.formatAmount(amount),
          declaredKm,
          storedKm
        }
      })
    }
  },
  mounted() {
    this.getImports()
  }
}
</script>

<style scoped>
.v-speed-dial {
  position: absolute;  
}

.v-btn--floating {
  position: relative;
}

</style>
